import * as THREE from "three";
import { State } from "../entities/OfferItem";
export class PickHandler {
    constructor(camera, canvasElement, scene) {
        this.raycaster = new THREE.Raycaster();
        this.clicked = false;
        this.init = true;
        this.scene = scene;
        this.canvasElement = canvasElement;
        this.meshes = [];
        this.camera = camera;
        this.pickPosition = new THREE.Vector2(0, 0);
        this.mouseMove = this.setPickPosition.bind(this);
        window.addEventListener('pointermove', this.mouseMove);
        this.pointerDown = this.onMouseDown.bind(this);
        window.addEventListener('pointerdown', this.pointerDown);
        this.pointerUp = this.isClicked.bind(this);
        window.addEventListener('pointerup', this.pointerUp);
    }
    set pickableObjects(mesh) {
        this.meshes.push(mesh);
    }
    /** We are listening to the clicks. If we click on the already opened ui the ui should not be closed
     * We do that, by finding the absolute div with the closest method. If it returns the element with the id extra_select it will return false.
     * @param event
     */
    onMouseDown(event) {
        this.setPickPosition(event);
        this.clientClickPos = new THREE.Vector2(event.clientX, event.clientY);
    }
    isClicked(event) {
        const x = event.clientX;
        const y = event.clientY;
        // Smooth it out
        let z;
        let k;
        if (x > this.clientClickPos.x)
            z = x - this.clientClickPos.x;
        else {
            z = this.clientClickPos.x - x;
        }
        if (y > this.clientClickPos.y)
            k = y - this.clientClickPos.y;
        else {
            k = this.clientClickPos.y - y;
        }
        if (z >= 2 && k >= 2)
            return;
        if (event.target.id === "modal-content" || event.target.id === "modal-1" || event.target.id === "modal-2" || event.target.id === "modal-bg") {
            this.clicked = false;
        }
        else if (event.target.closest(".transform") === null) {
            this.clicked = !this.clicked;
        }
        else if (event.target.closest(".transform") !== document.getElementById("extra_select")) {
            this.clicked = !this.clicked;
        }
        else {
            this.clicked = false;
        }
    }
    setPickPosition(event) {
        const pos = this.getCanvasRelativePosition(event);
        this.pickPosition.x = (pos.x / this.canvasElement.width) * 2 - 1;
        this.pickPosition.y = (pos.y / this.canvasElement.height) * -2 + 1;
    }
    // For mobile to stop picking based on mouse
    clearPickPosition() {
        this.pickPosition.x = -100000;
        this.pickPosition.y = -100000;
    }
    getCanvasRelativePosition(event) {
        const rect = this.canvasElement.getBoundingClientRect();
        return {
            x: (event.clientX - rect.left) * this.canvasElement.width / rect.width,
            y: (event.clientY - rect.top) * this.canvasElement.height / rect.height,
        };
    }
    /**
    * Invoked from render method.
    * Raycast between the mouse and camera position
    * If the raycast returns true with the specified mesh, we change the visibility of the mesh, and show the specific menu if the user clicks on it.
    * One limitation is that, we need different material for every pickable object
     * TODO new functions are implemented so the code became a little messy, needs a refactor
    * **/
    raycastHandler() {
        if (this.meshes) {
            if (this.scene.selectedSide && !this.pickedMesh) {
                this.meshes.forEach((mesh) => {
                    if (mesh.name === this.scene.selectedSide) {
                        this.pickedMesh = mesh;
                    }
                });
            }
            this.raycaster.setFromCamera(this.pickPosition, this.camera.threeCamera);
            const intersects = this.raycaster.intersectObjects(this.meshes);
            // Raycast returns true
            if (intersects.length > 0) {
                // Trying to fix a bug with instant select when the scene re-renders
                if (this.init === true) {
                    this.init = false;
                    return;
                }
                // We listen for the click while raycast returns true
                if (this.clicked === true) {
                    if (this.scene.formData.state === State.WALLSELECTING) {
                        this.scene.wall.selectWall(intersects, this.scene, this.scene.updateFormData);
                        this.scene.setSelectedSide(undefined);
                    }
                    else {
                        this.hoveredMesh = undefined;
                        if (this.pickedMesh) {
                            if (this.pickedMesh === intersects[0].object)
                                return;
                            let mat = this.pickedMesh.material;
                            mat.visible = false;
                            mat.color = new THREE.Color(0x28EBFB);
                            this.pickedMesh = intersects[0].object;
                            this.pickedMesh.visible = true;
                            mat = this.pickedMesh.material;
                            mat.color = new THREE.Color(0x951DFF);
                            mat.needsUpdate = true;
                            this.scene.setSelectedSide(intersects[0].object.name);
                        }
                        else {
                            this.scene.setSelectedSide(intersects[0].object.name);
                            this.pickedMesh = intersects[0].object;
                            this.pickedMesh.visible = true;
                            const mat = this.pickedMesh.material;
                            mat.color = new THREE.Color(0x951DFF);
                        }
                    }
                    this.clicked = false;
                }
                // We check if there was any hoovered object, to set it's visibility false again
                if (this.hoveredMesh) {
                    if (this.hoveredMesh !== intersects[0].object || this.hoveredMesh !== this.pickedMesh) {
                        this.intersectsHandler(intersects, true);
                        this.intersectsHandler(intersects, false);
                    }
                }
                else {
                    if (intersects[0].object) {
                        this.intersectsHandler(intersects, false);
                    }
                }
            }
            // Raycast is false
            else {
                // If there is no raycast intersects, we close the ui on click.
                if (this.clicked === true) {
                    if (this.pickedMesh) {
                        let mat = this.pickedMesh.material;
                        mat.visible = false;
                        mat.color = new THREE.Color(0x28EBFB);
                        this.pickedMesh = undefined;
                    }
                    this.scene.setSelectedSide(undefined);
                }
                this.clicked = false;
                if (this.hoveredMesh && this.pickedMesh) {
                    if (this.hoveredMesh.name !== this.pickedMesh.name)
                        this.intersectsHandler(intersects, true);
                }
                else if (this.hoveredMesh) {
                    this.intersectsHandler(intersects, true);
                }
            }
        }
    }
    /** Handle the material update logic on hover **/
    intersectsHandler(objects, remove) {
        if (remove === false)
            this.hoveredMesh = objects[0].object;
        const mat = this.hoveredMesh.material;
        //  We show the wallpicker instead of extrapicker.
        if (this.scene.formData.state === State.WALLSELECTING) {
            if (remove === false) {
                this.scene.sidePicker.wallSideMaterialContainer.setMaterialVisibility(this.hoveredMesh.name);
                mat.opacity = 0.8;
                mat.needsUpdate = true;
            }
            else {
                this.scene.sidePicker.wallSideMaterialContainer.setMaterialVisibility(this.hoveredMesh.name, true);
                mat.opacity = 0.4;
                mat.needsUpdate = true;
                this.hoveredMesh = undefined;
            }
        }
        else {
            if (remove === false) {
                mat.visible = true;
                mat.needsUpdate = true;
            }
            else {
                if (this.pickedMesh) {
                    if (this.pickedMesh !== this.hoveredMesh) {
                        mat.visible = false;
                        mat.needsUpdate = true;
                        this.hoveredMesh = undefined;
                    }
                }
                else {
                    mat.visible = false;
                    mat.needsUpdate = true;
                    this.hoveredMesh = undefined;
                }
            }
        }
    }
    // Removing listeners to avoid duplication. Refactor maybe needed cause we may not need to create new listeners.
    removeEventListeners() {
        window.removeEventListener('mousemove', this.mouseMove);
        window.removeEventListener('pointerdown', this.pointerDown);
        window.removeEventListener('pointerup', this.pointerUp);
    }
}
